import type { DesktopState } from '../state';
import { fmt, useTicker } from './LiveStatusBar';

export function ContactControl({ s, onReady, onPause, onPauseAfter, onOpen, callbackCount }: {
  s: DesktopState; onReady: () => void; onPause: () => void; onPauseAfter: (v: boolean) => void; onOpen: (m: DesktopState['modal']) => void; callbackCount: number;
}) {
  const now = useTicker();
  const busy = s.agentState === 'on_call' || s.agentState === 'reserved' || s.phase === 'dispo';
  return (
    <div id="x5-contact-control" className="panel">
      <div>
        <div className="agent">{s.session?.agent_id}</div>
        <div className="ext">{s.session?.tenant} · room {s.session?.room}</div>
      </div>
      <div>
        <div className="timer-label">{s.agentState === 'paused' ? `Paused${s.pauseCode ? ` (${s.pauseCode})` : ''}` : s.agentState === 'ready' ? 'Ready' : s.agentState.replace('_', ' ')}</div>
        <div className="timer">{fmt(now - s.stateSince)}</div>
      </div>
      <div className="row">
        <button className="success" onClick={onReady} disabled={busy || s.agentState === 'ready'}>ACTIVE</button>
        <button onClick={onPause} disabled={busy || s.agentState === 'paused'}>PAUSE</button>
      </div>
      <label className="check"><input type="checkbox" checked={s.pauseAfterCall} onChange={(e) => onPauseAfter(e.target.checked)} /> Pause after call</label>
      <button onClick={() => onOpen('callbacks')}>Callbacks{callbackCount ? ` (${callbackCount})` : ''}</button>
      <button disabled title="Phase 4">Next Contact (manual dial)</button>
      <button onClick={() => onOpen('calllog')}>Call Log</button>
    </div>
  );
}
